module.exports = __webpack_public_path__ + "static/media/heading-image.b4fa8354.png";


//////////////////
// WEBPACK FOOTER
// ./src/Imgs/heading-image.png
// module id = 60
// module chunks = 0